import { render, staticRenderFns } from "./LiabilitiesLoans.vue?vue&type=template&id=5049cf56"
import script from "./LiabilitiesLoans.vue?vue&type=script&lang=js"
export * from "./LiabilitiesLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports